import type { NotificationGetNotifications200NotificationsItem } from './notificationGetNotifications200NotificationsItem';
import type { NotificationGetNotifications200Pagination } from './notificationGetNotifications200Pagination';

/**
 * 알림 목록 응답 데이터
 */
export type NotificationGetNotifications200 = {
  /** 알림 목록 */
  notifications?: NotificationGetNotifications200NotificationsItem[];
  /** Spring Data Page 객체 형태의 페이징 정보 */
  pagination?: NotificationGetNotifications200Pagination;
  /** 읽지 않은 알림 수 */
  unreadCount?: number;
};
